import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/')({
  validateSearch: zodValidator(withDefaults(schema.MEASUREMENTS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermission, isInternalRole },
    } = context;

    const isAllowed = isInternalRole || hasAllowedPermission({ path: PAGE_PATHS.MEASUREMENTS });
    context.validatePermissions({ isAllowed, preload });
  },
});
